import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileManagementComponent } from './profile-management.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';

const routes: Routes = [
  { path: 'profile-management', component: ProfileManagementComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/profile-management/profile-management-routing.module.ts